const jivosite = document.createElement("script");

jivosite.async = true;
jivosite.src = "//code.jivosite.com/widget/wXhWvcFEAc";
document.head.appendChild(jivosite);
